import { ref, computed, onMounted, onUnmounted } from "vue";

// Shared singleton state — all components read from the same reactive refs
const width = ref(window.innerWidth);
let listenerCount = 0;

function updateWidth() {
    width.value = window.innerWidth;
}

const sizes = {
    sm: 640,
    md: 1024,
    lg: 1280,
    xl: 1536,
    "2xl": Infinity as number,
};

const currentSize = computed(() => {
    if (width.value < sizes.sm) return "sm";
    if (width.value < sizes.md) return "md";
    if (width.value < sizes.lg) return "lg";
    if (width.value < sizes.xl) return "xl";
    return "2xl";
});

export default function useScreenSize() {
    onMounted(() => {
        if (listenerCount === 0) {
            window.addEventListener("resize", updateWidth);
        }
        listenerCount++;
    });
    onUnmounted(() => {
        listenerCount--;
        if (listenerCount === 0) {
            window.removeEventListener("resize", updateWidth);
        }
    });

    return {
        size: currentSize,
        gt: (size: keyof typeof sizes) => width.value > sizes[size] && currentSize.value !== size,
        gte: (size: keyof typeof sizes) => width.value >= sizes[size],
        lt: (size: keyof typeof sizes) => width.value < sizes[size] && currentSize.value !== size,
        lte: (size: keyof typeof sizes) => width.value <= sizes[size],
        width,
    };
}